import React from 'react';
import { Organization, ManualSubscriptionStatusEnum } from '@EHSNavigator/backend';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import SidebarCrossIcon from '../../assets/icons/sidebar-cross-icon.svg?react';
import clsx from 'clsx';

interface OrganizationRequestActionsProps {
    organization: Organization;
    status?: string;
    onApprove: (org: Organization) => void;
    onReject: (org: Organization) => void;
    isApproveLoading?: boolean;
    isRejectLoading?: boolean;
}

const OrganizationRequestActions: React.FC<OrganizationRequestActionsProps> = ({
    organization,
    status,
    onApprove,
    onReject,
    isApproveLoading = false,
    isRejectLoading = false,
}) => {
    const currentStatus = status || organization.manualSubscription?.status;

    const renderActions = () => {
        switch (currentStatus) {
            case ManualSubscriptionStatusEnum.RequestAccess:
            case ManualSubscriptionStatusEnum.RequestExtension:
                return (
                    <>
                        <button
                            type="button"
                            onClick={() => onApprove(organization)}
                            disabled={isApproveLoading}
                            className={clsx(
                                'border-neutral-tones-text/10 bg-card-backgrounds/5 text-brand-papery hover:bg-brand-papery hover:text-white disabled:text-neutral-tones-text/50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border disabled:cursor-not-allowed transition-colors',
                                isApproveLoading && 'opacity-50',
                            )}
                            aria-label="Approve organization"
                        >
                            {isApproveLoading ? (
                                <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
                            ) : (
                                <GreenCheckIcon className="h-5 w-5 [&>path]:fill-current" />
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={() => onReject(organization)}
                            disabled={isRejectLoading}
                            className={clsx(
                                'border-neutral-tones-text/10 bg-card-backgrounds/5 text-brand-posh-pink hover:bg-brand-posh-pink hover:text-white disabled:text-neutral-tones-text/50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border disabled:cursor-not-allowed transition-colors',
                                isRejectLoading && 'opacity-50',
                            )}
                            aria-label="Reject organization"
                        >
                            {isRejectLoading ? (
                                <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
                            ) : (
                                <SidebarCrossIcon className="h-5 w-5 [&>g>path]:fill-current" />
                            )}
                        </button>
                    </>
                );

            case ManualSubscriptionStatusEnum.Active:
            case ManualSubscriptionStatusEnum.Rejected:
            case ManualSubscriptionStatusEnum.Expired:
            case ManualSubscriptionStatusEnum.Cancelled:
            case ManualSubscriptionStatusEnum.RejectedExtension:
            case ManualSubscriptionStatusEnum.Pending:
            default:
                return (
                    <button
                        type="button"
                        disabled
                        className="border-dashed border-neutral-tones-text/20 bg-transparent text-neutral-tones-text/30 flex h-8 w-8 cursor-not-allowed items-center justify-center rounded-md border"
                        aria-label="No actions available"
                    >
                        <span className="text-lg font-bold">—</span>
                    </button>
                );
        }
    };

    return (
        <div className="flex items-center gap-2">
            {renderActions()}
        </div>
    );
};

export default OrganizationRequestActions;

